import { render, staticRenderFns } from "./vistaComplementosFiador.vue?vue&type=template&id=87589644"
import script from "./vistaComplementosFiador.vue?vue&type=script&lang=js"
export * from "./vistaComplementosFiador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports